import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { keywordAdverDetail, keywordGroup } from 'lib/api/keywordcenter';
import FilterCollection from 'components/organisms/FilterCollection';
import { addAllList } from 'modules/common';
import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import queryString from 'query-string';

const KeywordDetail = ({ location }) => {
  const { adverId } = queryString.parse(location.search);
  let initParam = {
    sDate: moment().add(-1, 'day').format('YYYYMMDD'),
    eDate: moment().add(-1, 'day').format('YYYYMMDD'),
    kwrdGrpNo: 'all',
  };
  if (typeof adverId !== 'undefined') {
    initParam = {
      ...initParam,
      adverId,
    };
  }
  const { t } = useTranslation();
  const [initialization, setInitialization] = useState(false);
  const [keywordGroupList, setKeywordGroupList] = useState([]);
  const [params, setParams] = useState(initParam);

  useEffect(() => {
    getKeywordGroup(); // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setInitialization(false);
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {};

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParam);
  };

  const getParam = (newParams) => {
    setParams({
      ...params,
      ...newParams,
    });
  };

  /**
   * 키워드그룹 가져오는 함수
   */
  const getKeywordGroup = () => {
    keywordGroup({ adverId: adverId })
      .then((response) => {
        const { data } = response.data;
        setKeywordGroupList(data);
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useExternalFilter={false}
          useDisplayFilter={false}
          usePltfomTpCodeFilter={false}
        />
        <FilterCollection
          label={t('키워드그룹')}
          name="kwrdGrpNo"
          params={params}
          value={params.kwrdGrpNo}
          type="select"
          list={addAllList(
            keywordGroupList,
            'KWRD_GRP_NM',
            'KWRD_GRP_NO',
            'all'
          )}
          callBack={getParam}
          labelKey="KWRD_GRP_NM"
          valueKey="KWRD_GRP_NO"
        />
      </FilterWrap>
      <>
        <TableContainer
          dataReqPromise={keywordAdverDetail}
          params={{ ...params }}
          sort={'desc'}
          order={'ADVRTS_AMT'}
          limit={'100'}
          dense={true}
          customized={customized}
          hasExcel
        />
      </>
    </>
  );
};

export default withRouter(KeywordDetail);
